// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
'use strict';

var TypedGlamor = require("bs-typed-glamor/src/TypedGlamor.bs.js");

function root(isPublished) {
  return TypedGlamor.css(/* None */0, /* :: */[
              TypedGlamor.fontSize(TypedGlamor.em(0.85)),
              /* :: */[
                TypedGlamor.fontStyle(TypedGlamor.italic),
                /* :: */[
                  TypedGlamor.marginLeft(TypedGlamor.em(0.5)),
                  /* :: */[
                    TypedGlamor.select("> div", isPublished ? /* [] */0 : /* :: */[
                            TypedGlamor.textDecoration(TypedGlamor.lineThrough),
                            /* [] */0
                          ]),
                    /* [] */0
                  ]
                ]
              ]
            ]);
}

var tooltip = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.backgroundColor(TypedGlamor.white),
      /* :: */[
        TypedGlamor.boxShadows(/* :: */[
              TypedGlamor.shadow(TypedGlamor.px(1), TypedGlamor.px(1), /* Some */[TypedGlamor.px(3)], /* Some */[TypedGlamor.px(1)], /* None */0, TypedGlamor.rgba(0, 0, 0, 0.1)),
              /* [] */0
            ]),
        /* :: */[
          TypedGlamor.padding2(TypedGlamor.em(0.5), TypedGlamor.em(1)),
          /* :: */[
            TypedGlamor.select("& div", /* :: */[
                  TypedGlamor.whiteSpace(TypedGlamor.nowrap),
                  /* [] */0
                ]),
            /* [] */0
          ]
        ]
      ]
    ]);

exports.root = root;
exports.tooltip = tooltip;
/* tooltip Not a pure module */



// WEBPACK FOOTER //
// ./src/components/VersionStyles.js